export const RENDERING_CONTEXT_DEFAULT = 'default';
export const RENDERING_CONTEXT_MENU = 'menu';
export const RENDERING_CONTEXT_LPS = 'lp';

export const ALL_RENDERING_CONTEXTS = [
    RENDERING_CONTEXT_DEFAULT,
    RENDERING_CONTEXT_MENU,
    RENDERING_CONTEXT_LPS,
];
